(function () {
  function readTiers(el) {
    var raw = el && el.getAttribute('data-tiers');
    if (!raw) return null;
    var out = [0];
    var parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (!/^\d+(?:\.\d{1,2})?$/.test(part)) return null;
      var n = parseFloat(part);
      if (!isFinite(n) || n <= 0) return null;
      out.push(n);
    }
    return out.length > 1 ? out : null;
  }

  function euros(n) {
    var v = Math.round(n * 100) / 100;
    return (v % 1 ? v.toFixed(2) : String(v)).replace('.', ',') + ' €';
  }

  function init(root) {
    if (root.dataset.vwhReady) return;
    root.dataset.vwhReady = 'true';
    var TIERS = readTiers(root);
    var UNIT = TIERS ? TIERS[1] : 0;
    var max = parseInt(root.getAttribute('data-max'), 10) || 0;
    if (max < 1) max = TIERS ? TIERS.length - 1 : 5;
    if (TIERS && max >= TIERS.length) max = TIERS.length - 1;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-vwh-tile]'));
    var tiersEl = root.querySelector('[data-vwh-tiers]');
    var summaryEl = root.querySelector('[data-vwh-summary]');
    var cta = root.querySelector('[data-vwh-cta]');
    var ctaLabel = root.querySelector('[data-vwh-cta-label]');
    var countEl = root.querySelector('[data-vwh-count]');
    var emptyText = summaryEl ? summaryEl.textContent : '';
    var baseHref = cta ? cta.getAttribute('href').split('?')[0] : '';
    if (!tiles.length || !cta) return;

    var selected = [];
    function render() {
      var count = selected.length;
      tiles.forEach(function (t) {
        var on = selected.indexOf(t.getAttribute('data-num')) !== -1;
        var want = on ? 'true' : 'false';
        if (t.getAttribute('aria-pressed') !== want) t.setAttribute('aria-pressed', want);
        if (t.classList.contains('is-on') !== on) t.classList.toggle('is-on', on);
        var action = t.querySelector('[data-vwh-action]');
        if (action && !t.disabled) action.textContent = on ? 'Sélectionné · Retirer' : 'Ajouter au pack';
      });
      if (countEl) countEl.textContent = count + ' / ' + max + ' sélectionné' + (count !== 1 ? 's' : '');
      root.classList.toggle('is-full', count >= max);

      if (tiersEl) {
        var steps = tiersEl.querySelectorAll('[data-count]');
        for (var i = 0; i < steps.length; i++) {
          var n = parseInt(steps[i].getAttribute('data-count'), 10);
          steps[i].classList.toggle('is-active', count > 0 && n === Math.min(count, max));
          steps[i].classList.toggle('is-reached', count > 0 && n < Math.min(count, max));
        }
      }

      if (summaryEl) {
        summaryEl.textContent = '';
        if (count === 0) summaryEl.appendChild(document.createTextNode(emptyText));
        else {
          var priced = !!(TIERS && count < TIERS.length);
          var price = priced ? TIERS[count] : 0;
          var full = priced ? UNIT * count : 0;
          var saving = full - price;
          var main = document.createElement('span');
          main.className = 'vwh__summary-main';
          var strong = document.createElement('strong');
          strong.textContent = count + ' numéro' + (count !== 1 ? 's' : '') + (priced ? ' · ' + euros(price) : '');
          main.appendChild(strong);
          if (saving > 0) {
            var s = document.createElement('s');
            s.textContent = 'au lieu de ' + euros(full);
            main.appendChild(s);
          }
          summaryEl.appendChild(main);
          if (saving > 0) {
            var badge = document.createElement('span');
            badge.className = 'vwh__badge';
            badge.textContent = euros(saving) + ' économisés';
            summaryEl.appendChild(badge);
          }
        }
      }

      cta.setAttribute('href', count ? baseHref + '?pack=' + selected.join(',') : baseHref);
      cta.classList.toggle('is-ready', count > 0);
      if (ctaLabel) {
        var label = count > 0
          ? (cta.getAttribute('data-label-ready') || ctaLabel.textContent)
          : (cta.getAttribute('data-label-empty') || ctaLabel.textContent);
        if (ctaLabel.textContent !== label) ctaLabel.textContent = label;
      }
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.disabled) return;
        var num = t.getAttribute('data-num');
        var at = selected.indexOf(num);
        if (at !== -1) { selected.splice(at, 1); }
        else if (selected.length < max) selected.push(num);
        else return;
        render();
      });
    });

    render();
  }

  var roots = document.querySelectorAll('[data-vwh]');
  for (var i = 0; i < roots.length; i++) init(roots[i]);
  document.addEventListener('shopify:section:load', function (event) {
    var roots = event.target.querySelectorAll('[data-vwh]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  });
})();
